<div [class.with-floating-button]="isListeActionsVisible">
    <div class="content">
        <list-view [liste]="liste" *ngIf="liste"></list-view>
    </div>
    <floating-button [listeActions]="listeActions"></floating-button>
</div>
